// 📁 services/refreshService.ts

import axios from "axios";
import { config } from "./config";
import { saveTokens } from "@/utils/tokenStorage";

export const refreshAccessToken = async (refreshToken: string) => {
    try {
      const response = await axios.post(`${config.API_URL}/auth/refresh-token`, {
        refreshToken,
      });
      if(response.data.statusCode === 403) {
        return
      }

      const newAccessToken = String(response.data.access_token);
      const newRefreshToken = String(response.data.refresh_token);
      await saveTokens(newAccessToken, newRefreshToken);
  
      return {
        accessToken: newAccessToken,
        refreshToken: newRefreshToken,
      };
    } catch (error) {
      console.error("Error refreshing token:", error);
      throw error;
    }
  };
  
  
